import { Badge, Group, Paper, Stack, Text } from "@mantine/core";
import type {
  DeliveryRecallResult,
  RecallAttemptSummary,
} from "../../services/reportDeliveryRecall.service";
import { formatRecallScheduledTime } from "./RecallReportButton";

interface RecallHistoryAttemptCardProps {
  attempt: RecallAttemptSummary;
}

function sentenceCase(value: string): string {
  return value
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

function deliverySummary(delivery: DeliveryRecallResult): string {
  const recipient = delivery.recipientName?.trim() || "Unknown recipient";
  const destination = delivery.destination?.trim() || "destination unavailable";
  const method = delivery.deliveryMethodName?.trim() || "method unavailable";
  return `${recipient} • ${destination} • ${method}`;
}

export function RecallHistoryAttemptCard({
  attempt,
}: RecallHistoryAttemptCardProps) {
  return (
    <Paper withBorder p="md">
      <Stack gap="xs">
        <Group justify="space-between" align="flex-start" wrap="wrap">
          <Stack gap={2}>
            <Text fw={600}>{attempt.actor.displayName}</Text>
            <Text size="xs" c="dimmed">
              {formatRecallScheduledTime(attempt.attemptedAt)} • Report version{" "}
              {attempt.reportVersion ?? "unavailable"}
            </Text>
          </Stack>
          <Badge color={attempt.outcome === "recalled" ? "green" : "orange"}>
            {sentenceCase(attempt.outcome)}
          </Badge>
        </Group>
        <Text size="sm">Authority: {sentenceCase(attempt.authorityBasis)}</Text>
        <Text size="sm">
          Reason: {attempt.reason?.trim() || "No reason recorded"}
        </Text>
        {attempt.deliveries.map((delivery) => (
          <Paper key={delivery.queueItemId} withBorder p="xs">
            <Text size="sm" fw={500}>
              {deliverySummary(delivery)}
            </Text>
            <Text size="xs" c="dimmed">
              Scheduled {formatRecallScheduledTime(delivery.scheduledAt)} •{" "}
              {sentenceCase(delivery.result)}
            </Text>
          </Paper>
        ))}
      </Stack>
    </Paper>
  );
}
